import { XCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface ErrorDisplayProps {
  message: string;
  className?: string;
  variant?: "inline" | "full";
}

const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export function ErrorDisplay({
  message,
  className,
  variant = "inline",
}: ErrorDisplayProps) {
  if (!message) return null;

  if (variant === "full") {
    return (
      <div className="flex items-center justify-center mt-4 w-full">
        <div
          className={cn(
            "flex items-center gap-2 text-red-500 bg-red-50 px-4 py-3 rounded-lg",
            className
          )}
        >
          <XCircle className="w-5 h-5" />
          <span>{capitalizeFirstLetter(message)}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={cn("flex items-center gap-2 text-red-500", className)}>
      <XCircle className="w-4 h-4" />
      <span>{capitalizeFirstLetter(message)}</span>
    </div>
  );
}
